import { AfterViewInit, Component, inject } from '@angular/core';
import { AppMaterialModule } from '../../../../shared/app-material/app-material.module';
import { SharedModule } from '../../../../shared/shared.module';
import { GlobalConfigService } from '../../../../core/services/global-config.service';
import { SocialMediaComponent } from '../../../../shared/components/social-media/social-media.component';

@Component({
  selector: 'app-help-center',
  standalone: true,
  imports: [SharedModule, SocialMediaComponent],
  templateUrl: './help-center.component.html',
  styleUrl: './help-center.component.scss'
})
export class HelpCenterComponent {
  public globalConfig = inject(GlobalConfigService);

  openChat() {
    window.open(this.globalConfig.getContactNumber().redirectUrl, '_blank');
  }

  constructor() {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 50);
  }

}
